import React, { useEffect, useState } from 'react';
import HeaderPublic from '../../components/Navigation/HeaderPublic';
import Footer from '../../components/LandingPage/Footer';
import HeroSimuladorPonto from '../../components/LandingPage/RegistroPonto/HeroSimuladorPonto';
import BeneficiosPontoSection from '../../components/LandingPage/RegistroPonto/BeneficiosPontoSection';
import OfertaPontoSection from '../../components/LandingPage/RegistroPonto/OfertaPontoSection';

const PlanosRegistroPontoPage = () => {
    const [registered, setRegistered] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const previousTitle = document.title;
        document.title = 'Planos de Registro de Ponto | Higeia.tech';
        return () => {
            document.title = previousTitle;
        };
    }, []);

    return (
        <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
            <div className="border-b border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <HeaderPublic />
                </div>
            </div>

            <main>
                <HeroSimuladorPonto
                    registered={registered}
                    onRegistered={() => setRegistered(true)}
                />
                <BeneficiosPontoSection />
                <OfertaPontoSection />
            </main>

            <Footer />
        </div>
    );
};

export default PlanosRegistroPontoPage;
